export function TruckShippingIcon({
  color = '#3643BA',
  filledIcon = false,
  size = 16,
  className,
}: {
  color?: string
  filledIcon?: boolean
  size?: number
  className?: string
}) {
  return (
    <>
      {!filledIcon ? (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9141 3.74984C10.871 3.00622 10.2543 2.4165 9.49984 2.4165H2.49984C1.71743 2.4165 1.08317 3.05077 1.08317 3.83317V10.1665C1.08317 10.933 1.69183 11.5572 2.45216 11.5824C2.64928 12.7189 3.64029 13.5832 4.83317 13.5832C6.02577 13.5832 7.01661 12.7193 7.21405 11.5832H8.78562C8.98307 12.7193 9.9739 13.5832 11.1665 13.5832C12.3594 13.5832 13.3504 12.7189 13.5475 11.5824C14.3078 11.5572 14.9165 10.933 14.9165 10.1665V6.87475C14.9165 6.5866 14.8286 6.30529 14.6646 6.06837L13.482 4.36012C13.2174 3.97791 12.7821 3.74984 12.3172 3.74984H10.9141ZM10.9165 5.24984H12.2735L13.4165 6.90079V10.0832H13.3273C12.9301 9.29245 12.1117 8.74984 11.1665 8.74984C11.0821 8.74984 10.9987 8.75417 10.9165 8.76261V5.24984ZM9.4165 9.49983C9.25243 9.67205 9.11352 9.86847 9.00567 10.0832H6.99401C6.59681 9.29245 5.77836 8.74984 4.83317 8.74984C3.88799 8.74984 3.06954 9.29245 2.67234 10.0832H2.58317V3.9165H9.4165V9.49983ZM11.1665 10.2498C11.6728 10.2498 12.0832 10.6602 12.0832 11.1665C12.0832 11.6728 11.6728 12.0832 11.1665 12.0832C10.6602 12.0832 10.2498 11.6728 10.2498 11.1665C10.2498 10.6602 10.6602 10.2498 11.1665 10.2498ZM4.83317 10.2498C5.33943 10.2498 5.74984 10.6602 5.74984 11.1665C5.74984 11.6728 5.33943 12.0832 4.83317 12.0832C4.32691 12.0832 3.9165 11.6728 3.9165 11.1665C3.9165 10.6602 4.32691 10.2498 4.83317 10.2498Z"
            fill={color}
          />
        </svg>
      ) : (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <g clipPath="url(#clip0_3219_503)">
            <path
              d="M11.3332 5.33334H13.3332L15.3332 8.03734V12H13.9765C13.8973 12.5562 13.62 13.0651 13.1956 13.4333C12.7713 13.8015 12.2283 14.0042 11.6665 14.0042C11.1047 14.0042 10.5617 13.8015 10.1374 13.4333C9.71303 13.0651 9.43576 12.5562 9.3565 12H5.9765C5.89725 12.5562 5.61998 13.0651 5.19562 13.4333C4.77127 13.8015 4.22832 14.0042 3.6665 14.0042C3.10469 14.0042 2.56174 13.8015 2.13738 13.4333C1.71303 13.0651 1.43576 12.5562 1.3565 12H0.666504V4.00001C0.666504 3.8232 0.736742 3.65363 0.861766 3.52861C0.98679 3.40358 1.15636 3.33334 1.33317 3.33334H10.6665C10.8433 3.33334 11.0129 3.40358 11.1379 3.52861C11.2629 3.65363 11.3332 3.8232 11.3332 4.00001V5.33334ZM11.3332 6.66668V8.66668H13.9998V8.47668L12.6612 6.66668H11.3332Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_3219_503">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  )
}
